var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4142 3.58579C21.1953 4.36683 21.1953 5.63316 20.4142 6.41421L14.8284 12L20.4142 17.5858C21.1953 18.3669 21.1953 19.6332 20.4142 20.4142C19.6332 21.1953 18.3668 21.1953 17.5858 20.4142L12 14.8284L6.41421 20.4142C5.63316 21.1953 4.36683 21.1953 3.58579 20.4142C2.80474 19.6332 2.80474 18.3668 3.58579 17.5858L9.17157 12L3.58579 6.41422C2.80474 5.63317 2.80474 4.36685 3.58579 3.5858C4.36683 2.80475 5.63316 2.80475 6.41421 3.5858L12 9.17159L17.5858 3.58579C18.3668 2.80474 19.6332 2.80474 20.4142 3.58579Z",
    fill: "#EA563D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.1b774b4f15bf4be78959cc3e3e9c1386.svg";
export { ForwardRef as ReactComponent };